<template>
  <div class="advice1-wrap">
    <main class="screen" role="main">

      <div class="header">
        <button
          type="button"
          class="back-button"
          @click="goBack"
          aria-label="Zurück"
        >←</button>
        <span class="breadcrumb">Lebensmittelgruppen</span>
      </div>

      <div class="hero">
        <div class="hero-emoji" aria-hidden="true">{{ group.emoji }}</div>
        <h1 class="hero-title">{{ group.name }}</h1>
        <p class="hero-subtitle">{{ group.subtitle }}</p>
      </div>

      <div class="section">
        <h2 class="section-title">Warum sie wichtig sind</h2>
        <p class="section-text">{{ group.why }}</p>
      </div>

      <div class="recommendation-card">
        <p class="recommendation-label">Empfehlung SGE</p>
        <p class="recommendation-text">{{ group.recommendation }}</p>
      </div>

      <div class="section">
        <h2 class="section-title">Einfache Ideen</h2>
        <ul class="ideas-list">
          <li v-for="(idea, i) in group.ideas" :key="i">
            <span class="idea-emoji" aria-hidden="true">{{ idea.emoji }}</span>
            <div class="idea-content">
              <p class="idea-name">{{ idea.name }}</p>
              <p class="idea-detail">{{ idea.detail }}</p>
            </div>
          </li>
        </ul>
      </div>

      <p class="placeholder-note">Beispieltexte. Die finalen Inhalte werden vom Ernährungsteam erstellt.</p>

    </main>
  </div>
</template>

<script>
export default {
  name: 'Advice1',
  data() {
    return {
      group: {
        emoji: '🌱',
        name: 'Hülsenfrüchte',
        subtitle: 'Linsen, Kichererbsen, Bohnen, Erbsen, Hummus',
        why: 'Hülsenfrüchte sind eine wertvolle pflanzliche Proteinquelle und liefern viele Ballaststoffe. Sie sättigen lange, sind günstig und gut lagerfähig. In der Schweizer Ernährung kommen sie oft zu kurz.',
        recommendation: 'Mindestens 1 Portion pro Woche, gerne mehr. Eine Portion entspricht ca. 60–80 g trocken oder 150 g gekocht.',
        ideas: [
          { emoji: '🥗', name: 'Linsensalat', detail: 'Mit Essig, Öl, Zwiebel und Kräutern, hält 2–3 Tage im Kühlschrank.' },
          { emoji: '🍞', name: 'Hummus aufs Brot', detail: '2 EL Hummus = ca. eine halbe Portion. Geht auch als Dip mit Gemüsesticks.' },
          { emoji: '🍲', name: 'Kichererbsen-Curry', detail: 'Schnell gemacht mit Dose Kichererbsen, Tomaten und Gewürzen.' },
          { emoji: '🍵', name: 'Linsensuppe', detail: 'Klassiker, sättigt lange, gut zum Vorkochen.' },
        ],
      },
    };
  },
  methods: {
    goBack() { this.$router.back(); },
  },
};
</script>

<style scoped>
.advice1-wrap {
  --color-bg-page: #f5f4ef;
  --color-bg-card: #ffffff;
  --color-bg-muted: #f1efe8;
  --color-text-primary: #2c2c2a;
  --color-text-secondary: #5f5e5a;
  --color-text-tertiary: #888780;
  --color-border: rgba(0, 0, 0, 0.15);
  --color-accent: #534AB7;
  --color-accent-light: #EEEDFE;
  --radius-md: 8px;
  --radius-lg: 12px;
  --font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  background: var(--color-bg-page);
  font-family: var(--font-sans);
  color: var(--color-text-primary);
  line-height: 1.5;
  min-height: 100%;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
}

.advice1-wrap *,
.advice1-wrap *::before,
.advice1-wrap *::after {
  box-sizing: border-box;
}

.screen {
  width: 100%;
  max-width: 420px;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  border: 0.5px solid var(--color-border);
  padding: 1.5rem 1.25rem;
  min-height: 600px;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}

.back-button {
  background: transparent;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 20px;
  color: var(--color-text-secondary);
  line-height: 1;
}

.breadcrumb {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin-left: 8px;
}

.hero {
  background: var(--color-accent-light);
  border-radius: var(--radius-lg);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.hero-emoji {
  font-size: 56px;
  line-height: 1;
  margin-bottom: 12px;
}

.hero-title {
  font-size: 24px;
  font-weight: 500;
  margin: 0 0 8px;
  color: var(--color-text-primary);
}

.hero-subtitle {
  font-size: 14px;
  color: var(--color-accent);
  margin: 0;
}

.section {
  margin-bottom: 1.5rem;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 8px;
  color: var(--color-text-primary);
}

.section-text {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0 0 8px;
  line-height: 1.6;
}

.recommendation-card {
  background: var(--color-bg-muted);
  border-radius: var(--radius-md);
  padding: 14px 16px;
  margin-bottom: 1.5rem;
}

.recommendation-label {
  font-size: 12px;
  color: var(--color-text-secondary);
  margin: 0 0 4px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.recommendation-text {
  font-size: 15px;
  color: var(--color-text-primary);
  margin: 0;
  font-weight: 500;
}

.ideas-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ideas-list li {
  display: flex;
  gap: 12px;
  padding: 12px 14px;
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-bg-card);
}

.idea-emoji {
  flex-shrink: 0;
  font-size: 22px;
  line-height: 1;
}

.idea-content { flex: 1; }

.idea-name {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 2px;
  color: var(--color-text-primary);
}

.idea-detail {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0;
  line-height: 1.4;
}

.placeholder-note {
  font-size: 11px;
  color: var(--color-text-tertiary);
  text-align: center;
  margin-top: 1.5rem;
  font-style: italic;
}
</style>
